import { flatten } from 'lodash';

import { SEARCH_FACETS_FOR_URL_SYNC } from 'bundles/search-common/constants/filter';

function manipulateFiltersForEventing(facetFilters?: string[][]): string[] | undefined {
  const flattenedFilters = flatten(facetFilters);
  if (!flattenedFilters?.length) return undefined;
  return flattenedFilters.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
}

function extractFiltersForEventing(url: string) {
  const [urlWithoutFragment] = url.split('#'); // Remove the fragment part of the URL if it exists
  // @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const urlParams = new URLSearchParams(urlWithoutFragment.split('?')[1]);
  const filters = [];

  for (const [key, value] of urlParams.entries()) {
    if (SEARCH_FACETS_FOR_URL_SYNC.includes(key)) filters.push(`${key}:${value}`);
  }

  return manipulateFiltersForEventing([filters]);
}

export { manipulateFiltersForEventing, extractFiltersForEventing };
